import React from 'react';

export function nl2brJSX(str: string, replaceStr = '\n', prependStr = '') {
  return str.split(replaceStr).map((item, key) => {
    return (
      <span key={key}>
        {item}
        {prependStr}
        <br />
      </span>
    );
  });
}
